export default __webpack_public_path__ + "static/om-95a4163591dd9474d246789378255500.svg";